import React from "react";
import PropTypes from "prop-types";
import { Text } from "./base/index";
import Topic from "./Topic";
import HeadingWrapper from "./HeadingWrapper";
import { createStatusInfo } from "../utils/contentStatusUtils";
import { PageStateContext, ChapterContext } from "../PageContext";
import { debugLog, renderHtmlString } from "../utils/index";
import dciLogo from "../images/DCI.png";

// Permalink icon: DCI logo linking to the universal /link/ page
const DigiGuideLinkIcon = ({ href }) => (
  <a
    href={href}
    title="Universal Link"
    style={{ marginLeft: "0.35em", display: "inline-flex", alignItems: "center", justifyContent: "center", width: "18px", height: "18px", background: "#0B83FF", borderRadius: "3px", verticalAlign: "middle", textDecoration: "none", flexShrink: 0 }}
  >
    <img src={dciLogo} alt="Universal Link" style={{ width: "12px", height: "12px", objectFit: "contain" }} />
  </a>
);

const Chapter = ({
  title = "",
  htmlTitle = undefined,
  topics = [],
  isFirst = false,
  changedType = null,
  changedData = {},
  id = null,
}) => {
  const { pageState } = React.useContext(PageStateContext);
  const { chrome, isWebView, manualId } = pageState;
  const { pageLayoutType } = chrome;
  const isQSG = pageLayoutType === "QSG";

  debugLog("Chapter pageLayoutType", pageLayoutType);
  // Handle empty topics gracefully
  const topicList = topics || [];
  debugLog(
    "Chapter topic ids",
    topicList.map(item => item.id)
  );

  // New util replaces checkChangedData
  const changedTypeInfo = createStatusInfo(
    changedType,
    changedType ? "Changed" : ""
  );
  const tooltipCls = changedTypeInfo.status
    ? "edited-success tooltip"
    : "edited-error tooltip";

  // Use the chapter ID or a fallback identifier for consistent linking
  const chapterIdentifier =
    id || title || `chapter-${isFirst ? "1" : "unknown"}`;

  const renderedHtmlTitle = htmlTitle ? renderHtmlString(htmlTitle) : title;
  return (
    <ChapterContext.Provider value={id || null}>
    <div className={isFirst ? "chapter" : "chapter page-break"}>
      {renderedHtmlTitle && renderedHtmlTitle !== " " && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4em' }}>
          <HeadingWrapper
            text={renderedHtmlTitle}
            type="chapter"
            identifier={id ? `cid-${id}` : chapterIdentifier}
            className=""
            style={{ flex: '1 1 auto', minWidth: 0 }}
          >
            <Text
              tag="h2"
              className={`${
                changedType ? tooltipCls : "mb-0"
              } title-chapter break-after-avoid ${
                isQSG ? "color: blue-500" : ""
              }`}
            >
              {changedType && changedData
                ? renderHtmlString(changedData.entryName)
                : renderHtmlString(renderedHtmlTitle)}
              {changedType && (
                <span className="tooltiptext">{changedTypeInfo.msg}</span>
              )}
            </Text>
          </HeadingWrapper>
          {isWebView && id && manualId && (
            <span style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
              <DigiGuideLinkIcon href={`/link/Chapter?id=${id}&manualId=${manualId}`} />
            </span>
          )}
        </div>
      )}
      {topicList.length > 0 ? (
        topicList.map((item, topicIndex) => (
          <Topic
            key={item.id}
            entry={item}
            chapterIdentifier={chapterIdentifier}
            topicIndex={topicIndex}
          />
        ))
      ) : (
        <></>
      )}
    </div>
    </ChapterContext.Provider>
  );
};

Chapter.propTypes = {
  title: PropTypes.string,
  htmlTitle: PropTypes.string,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string,
      htmlTitle: PropTypes.string,
      content: PropTypes.arrayOf(PropTypes.object),
      steps: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  isFirst: PropTypes.bool,
  changedType: PropTypes.number,
  changedData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  id: PropTypes.number,
};

export default Chapter;
